import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Modal, Form, Table, Badge } from 'react-bootstrap';
import { toast } from 'react-toastify';

const BalanceRequest = () => {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    amount: '',
    requestTo: 'Company',
    paymentMethod: 'Credit',
    paymentMode: 'Credit',
    transactionDate: new Date().toISOString().split('T')[0],
    remarks: ''
  });

  // Sample balance request history
  const requestHistory = [
    { 
      id: 'BR001', 
      date: '2024-11-05 10:30 AM', 
      amount: '10000', 
      requestTo: 'Distributor',
      paymentMethod: 'Credit',
      status: 'Approved',
      remarks: 'NEFT Transfer - Ref: 123456'
    },
    { 
      id: 'BR002', 
      date: '2024-11-04 03:20 PM', 
      amount: '25000', 
      requestTo: 'Distributor',
      paymentMethod: 'Credit',
      status: 'Pending',
      remarks: 'IMPS Transfer - Ref: 789012'
    },
    { 
      id: 'BR003', 
      date: '2024-11-03 11:15 AM', 
      amount: '15000', 
      requestTo: 'Distributor',
      paymentMethod: 'Credit',
      status: 'Approved',
      remarks: 'UPI Transfer - Ref: 345678'
    },
    { 
      id: 'BR004', 
      date: '2024-11-02 09:45 AM', 
      amount: '5000', 
      requestTo: 'Distributor',
      paymentMethod: 'Credit',
      status: 'Rejected',
      remarks: 'Cash Deposit - Invalid Receipt'
    },
    { 
      id: 'BR005', 
      date: '2024-11-01 02:30 PM', 
      amount: '20000', 
      requestTo: 'Distributor',
      paymentMethod: 'Credit',
      status: 'Approved',
      remarks: 'RTGS Transfer - Ref: 901234'
    }
  ];

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    // Reset form
    setFormData({
      amount: '',
      requestTo: 'Company',
      paymentMethod: 'Credit',
      paymentMode: 'Credit',
      transactionDate: new Date().toISOString().split('T')[0],
      remarks: ''
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // if (!formData.amount || parseFloat(formData.amount) < 100) {
    //   alert('Please enter a valid amount (minimum ₹100)');
    //   return;
    // }

    // Simulate API call
    toast.success(`Balance request of ₹${formData.amount} submitted successfully!`);
    handleCloseModal();
  };

  const getStatusColor = (status) => {
    switch(status) {
      case 'Approved': return 'success';
      case 'Pending': return 'warning';
      case 'Rejected': return 'danger';
      default: return 'secondary';
    }
  };

  return (
    <Container fluid className="balance-request-page p-4">
      {/* Page Header */}
      <div className="page-header mb-4 d-flex justify-content-between align-items-center">
        <div>
          <h2 className="mb-1" style={{ fontSize: '24px', fontWeight: 600, color: '#2c2268' }}>
            <i className="bi bi-wallet2 me-2"></i>
            Balance Request
          </h2>
          {/* <p className="text-muted mb-0">Request balance from your distributor</p> */}
        </div>
        <Button
          onClick={handleOpenModal}
          style={{
            backgroundColor: '#1e1850',
            border: 'none',
            padding: '10px 24px',
            borderRadius: '6px',
            fontWeight: 600,
            fontSize: '15px',
            boxShadow: '0 4px 6px rgba(30, 24, 80, 0.3)'
          }}
        >
          <i className="bi bi-plus-circle me-2"></i>
          New Request
        </Button>
      </div>

      {/* Balance Request History */}
      <Row>
        <Col>
          <Card className="shadow-sm border-0">
            <Card.Header className="bg-white border-bottom" style={{ padding: '16px 24px' }}>
              <h5 className="mb-0" style={{ fontWeight: 600, color: '#2c2268' }}>
                <i className="bi bi-clock-history me-2"></i>
                Request History
              </h5>
            </Card.Header>
            <Card.Body className="p-0">
              <div className="table-responsive">
                <Table hover className="mb-0">
                  <thead style={{ backgroundColor: '#f8f9fa' }}>
                    <tr>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Request ID
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Date
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Amount
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Request To
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Payment Method
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Status
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Remarks
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {requestHistory.map((request, index) => (
                      <tr key={index} style={{ transition: 'background-color 0.2s' }}>
                        <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', fontWeight: 600 }}>
                          {request.id}
                        </td>
                        <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>
                          {request.date}
                        </td>
                        <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', fontWeight: 600 }}>
                          ₹{request.amount}
                        </td>
                        <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>
                          {request.requestTo}
                        </td>
                        <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>
                          {request.paymentMethod}
                        </td>
                        <td style={{ padding: '12px 16px' }}>
                          <Badge 
                            bg={getStatusColor(request.status)}
                            style={{ 
                              fontSize: '11px',
                              padding: '4px 10px',
                              fontWeight: 500
                            }}
                          >
                            {request.status}
                          </Badge>
                        </td>
                        <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>
                          {request.remarks}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Balance Request Modal */}
      <Modal show={showModal} onHide={handleCloseModal} centered dialogClassName="retailer-modal">
        <Modal.Header closeButton style={{ borderBottom: '1px solid #dee2e6', padding: '16px 24px' }}>
          <Modal.Title style={{ fontSize: '20px', fontWeight: 600, color: '#333' }}>
            Balance Request
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '24px' }}>
          <Form onSubmit={handleSubmit}>
            {/* Amount */}
            <Form.Group className="mb-3">
              <Form.Label>Amount</Form.Label>
              <Form.Control
                type="text"
                name="amount"
                placeholder="Enter Amount"
                value={formData.amount}
                onChange={handleInputChange}
                required
              />
            </Form.Group>

            {/* Request To and Payment Method Row */}
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Request To</Form.Label>
                  <Form.Select
                    name="requestTo"
                    value={formData.requestTo}
                    onChange={handleInputChange}
                  >
                    <option value="Company">24Pay</option>
                    <option value="Distributor">Distributor</option>
                    <option value="Master Distributor">Master Distributor</option>
                    <option value="Super Distributor">Super Distributor</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Payment Method</Form.Label>
                  <Form.Select
                    name="paymentMethod"
                    value={formData.paymentMethod}
                    onChange={handleInputChange}
                  >
                    <option value="Credit">Credit</option>
                    <option value="Bank Transfer">Bank Transfer</option>
                    <option value="Cash Deposit">Cash Deposit</option>
                    <option value="UPI">UPI</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            {/* Payment Mode and Transaction Date Row */}
            <Row>
              {/* <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Payment Mode</Form.Label>
                  <Form.Select
                    name="paymentMode"
                    value={formData.paymentMode}
                    onChange={handleInputChange}
                  >
                    <option value="Credit">Credit</option>
                    <option value="Debit">Debit</option>
                  </Form.Select>
                </Form.Group>
              </Col> */}
              {/* <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Transaction Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="transactionDate"
                    value={formData.transactionDate}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col> */}
            </Row>

            {/* Remarks */}
            <Form.Group className="mb-3">
              <Form.Label>Remarks</Form.Label>
              <Form.Control
                type="text"
                name="remarks"
                placeholder="Remarks / Bank Ref No."
                value={formData.remarks}
                onChange={handleInputChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: '1px solid #dee2e6', padding: '16px 24px' }}>
          <Button
            variant="secondary"
            onClick={handleCloseModal}
            style={{
              padding: '8px 20px',
              fontSize: '14px',
              fontWeight: 500,
              borderRadius: '4px'
            }}
          >
            Close
          </Button>
          <Button
            onClick={handleSubmit}
            className="send-button"
            style={{
              backgroundColor: 'transparent',
              border: '2px solid #0d6efd',
              color: '#0d6efd',
              padding: '8px 20px',
              fontSize: '14px',
              fontWeight: 600,
              borderRadius: '4px',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#0d6efd';
              e.currentTarget.style.color = 'white';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#0d6efd';
            }}
          >
            Send
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Custom Styles */}
      <style jsx="true">{`
        .balance-request-page {
          background-color: #fff;
          min-height: calc(100vh - 100px);
        }

        .table tbody tr:hover {
          background-color: #f8f9fa;
        }

        .modal-content {
          border-radius: 8px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
        }

        .modal-header .btn-close {
          padding: 0.5rem;
        }

        @media (max-width: 768px) {
          .table-responsive {
            overflow-x: auto;
          }
        }
      `}</style>
    </Container>
  );
};

export default BalanceRequest;

